import React, { useState, useEffect } from "react";
import moment from "moment";
import ReactRoundedImage from "react-rounded-image";
import { Redirect } from "react-router-dom";
import { Col, Row, Container, FormGroup, Input, Label } from "reactstrap";
import { convertStringToDate } from "../../../../utils/functions";
var customerName = localStorage.getItem("companyCustomerName");
var companyName = localStorage.getItem("companyName");
let currentDate = moment(new Date()).format("YYYY-MM-DD");
var UserName = localStorage.getItem("firstName");
var token = localStorage.getItem("token");
var companyId = localStorage.getItem("companyId");
let companySym = localStorage.getItem("profile_pic");

export default function Greeting(props) {
  // console.log("props :>> ", props);
  var masterData = props?.history?.location?.state1;

  var detData = props?.history?.location?.state2?.formValues;
  var totalSum = props?.history?.location?.state3;
  var partnerData = props?.history?.location?.state4?.formValues;
  // console.log("totalSum :>> ", totalSum);
  // console.log("partnerData :>> ", partnerData);

  const [data, setData] = useState({
    dynamicInvMessage: props?.location?.state?.dynamicInvMessage,
    reportName: props?.location?.state?.reportName,
    companyName: localStorage.getItem("companyName"),
    criteria: props?.location?.state?.criteria,
  });
  function due_FormatorsAmts(cell, row, enumObject, index) {
    let newCell = "";
    newCell = cell;
    if (typeof cell === "string") {
      newCell = Number(cell);
    }
    if (newCell) {
      newCell = newCell?.toLocaleString("en-US", {
        // maximumFractionDigits: 2,
        // minimumFractionDigits: 2,
      });
      // newCell = companySymbolCurrency + " " + newCell;
    } else {
      newCell = "-";
    }
    return newCell;
  }
  function due_FormatorsPer(cell, row, enumObject, index) {
    let newCell = "";
    newCell = cell;
    if (typeof cell === "string") {
      newCell = Number(cell);
    }
    if (newCell) {
      newCell = newCell?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
      // newCell = companySymbolCurrency + " " + newCell;
    } else {
      newCell = "-";
    }
    return newCell;
  }
  useEffect(() => {
    let logInStatus = false;
    const token = localStorage.getItem("token");
    if (token != null) {
      logInStatus = true;
    }
    if (logInStatus === false) {
      return <Redirect to="/login" />;
    }
  }, []);

  const goBackFun = () => {
    let pathName = props?.location?.state?.goBackUrl;
    props.history.push({
      pathname: "/DealOverview",
    });
  };

  return (
    <div>
      <Row className="app-body-Invoice bg-white rounded-lg shadow py-2">
        <Col xs="12">
          <Container>
            <Row className="my-2">
              <Col md="3">
                <span className="PR_invoice_img">
                  {" "}
                  <ReactRoundedImage
                    className="ReactRoundedImage"
                    image={companySym}
                    roundedColor="#321124"
                    imageWidth="120"
                    imageHeight="120"
                    roundedSize="4"
                  />
                </span>
              </Col>
              <Col md="6">
                <h2 className="text-center">{companyName}</h2>
                <h2 className="text-center">{"Company Deal Form"}</h2>
                <h5 className="text-center "></h5>
              </Col>
              <Col md="3">
                <div style={{ textAlign: "end" }}>
                  <button
                    className="btn btn-primary mx-2"
                    id="printPageButton"
                    onClick={() => {
                      window.print();
                    }}
                  >
                    Print to PDF!
                  </button>
                  <button
                    className="btn btn-primary m-1"
                    id="printPageButton"
                    onClick={() => {
                      goBackFun();
                    }}
                  >
                    Back
                  </button>
                </div>
              </Col>
            </Row>
          </Container>

          <Row className="my-1">
            <Container>
              <Row>
                <Col md="2" className="border">
                  {" "}
                  <h5>Deal No : </h5>
                </Col>
                <Col md="5" className="border">
                  {" "}
                  <h5>
                    <span className="h5 text-muted">{masterData?.dealNo}</span>
                  </h5>
                </Col>
                {/* <Col md="2" className="border">
                  {" "}
                </Col> */}
                <Col md="2" className="border">
                  {" "}
                  <h5>Deal Date : </h5>
                </Col>
                <Col md="3" className="border">
                  {" "}
                  <span className="h5 text-muted">
                    {convertStringToDate({
                      format: "dmy",
                      dateParam: masterData?.dealDate,
                    })}
                    {/* {moment(masterData?.dealDate).format("YYYY-MM-DD")} */}
                  </span>
                </Col>
                <Col md="2" className="border">
                  {" "}
                  <h5>Target Date : </h5>
                </Col>
                <Col md="10" className="border">
                  {" "}
                  <span className="h5 text-muted">
                    {convertStringToDate({
                      format: "dmy",
                      dateParam: masterData?.targetDate,
                    })}
                  </span>
                </Col>
                <Col md="9" className="border">
                  {" "}
                </Col>
              </Row>
              <Row>
                <Col md="2" className="border">
                  {" "}
                  <h5>Company Name: </h5>
                </Col>
                <Col md="10" className="border">
                  {" "}
                  <span className="h5 text-muted">
                    {masterData?.companyName?.label}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col md="2" className="border">
                  {" "}
                  <h5>Deal Description: </h5>{" "}
                </Col>
                <Col md="10" className="border">
                  {" "}
                  <span className="h5 text-muted">
                    {masterData?.dealDescription}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col md="2" className="border">
                  <h5>Society : </h5>
                </Col>
                <Col md="10" className="border">
                  <span className="h5 text-muted">
                    {masterData?.societyId?.label}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col md="2" className="border">
                  <h5>Sector/Phase : </h5>
                </Col>
                <Col md="10" className="border">
                  <span className="h5 text-muted">
                    {masterData?.sectorId?.label}
                  </span>
                </Col>
              </Row>

              <Row>
                <Col md="2" className="border">
                  <h5>Middle Man : </h5>
                </Col>
                <Col md="10" className="border">
                  <span className="h5 text-muted">
                    {masterData?.midManId?.label}
                  </span>
                </Col>
              </Row>

              <Row>
                <Col md="2" className="border">
                  <h5>Remarks : </h5>
                </Col>
                <Col md="10" className="border">
                  <span className="h5 text-muted">{masterData?.remarks}</span>
                </Col>
              </Row>
              <Row style={{ marginTop: "4rem" }}>
                <Col md="3" className="border">
                  {""}
                </Col>
              </Row>
            </Container>
          </Row>
          <Row className="my-0">
            <Container>
              <Row>
                <Col md="2" className="border">
                  <h5>UnitNo</h5>{" "}
                </Col>
                <Col md="2" className="border">
                  <h5 style={{}}>Type</h5>
                </Col>
                <Col md="1" className="border">
                  <h5 style={{}}>Category</h5>
                </Col>
                <Col md="1" className="border">
                  <h5 style={{}}>Size</h5>
                </Col>
                <Col md="2" className="border">
                  <h5 className="text-right">Company Price</h5>
                </Col>
                <Col md="2" className="border">
                  <h5 className="text-right">Commission</h5>
                </Col>
                <Col md="2" className="border">
                  <h5 className="text-right">Total Cost</h5>
                </Col>
              </Row>

              {detData?.map((detDataArray) => (
                <Row style={{ marginBottom: "-7px" }}>
                  <Col md="2" className="h5 text-muted border">
                    <h5>{detDataArray?.unitNo}</h5>{" "}
                  </Col>
                  <Col md="2" className="h5 text-muted border">
                    <h5 style={{}}>{detDataArray?.type?.label}</h5>
                  </Col>
                  <Col md="1" className="h5 text-muted border">
                    <h5 style={{}}>{detDataArray?.category?.label}</h5>
                  </Col>
                  <Col md="1" className="h5 text-muted border">
                    <h5 style={{}}>{detDataArray?.size?.label}</h5>
                  </Col>
                  <Col md="2" className="h5 text-muted border">
                    <h5 className="text-right">
                      {due_FormatorsAmts(detDataArray?.companyPrice)}
                    </h5>
                  </Col>
                  <Col md="2" className="h5 text-muted border">
                    <h5 className="text-right">
                      {due_FormatorsAmts(detDataArray?.commission)}
                    </h5>
                  </Col>
                  <Col md="2" className="h5 text-muted border">
                    <h5 className="text-right">
                      {due_FormatorsAmts(detDataArray?.totalCost)}
                    </h5>
                  </Col>
                </Row>
              ))}
              <Row>
                <Col md="1" className="h5 text-muted "></Col>
                <Col md="2" className="h5 text-muted "></Col>
                <Col md="2" className="h5 text-right "></Col>
                <Col md="1" className="h5  text-left">
                  Total:
                </Col>
                <Col md="2" className="h5 border">
                  <h5 className="text-right">
                    {due_FormatorsAmts(totalSum?.totalComPrice)}
                  </h5>
                </Col>
                <Col md="2" className="h5 border">
                  <h5 className="text-right">
                    {due_FormatorsAmts(totalSum?.totalCommission)}
                  </h5>
                </Col>
                <Col md="2" className="h5 border">
                  <h5 className="text-right">
                    {due_FormatorsAmts(totalSum?.totalCost)}
                  </h5>
                </Col>
              </Row>
              {/* <Row style={{ marginTop: "4rem" }}>
                <Col md="1" className="h5 text-muted border">
                  <h5 className="text-right">{totalSum?.companyPrice}</h5>
                </Col>
                <Col md="1" className="h5 text-muted border">
                  <h5 className="text-right">{totalSum?.commission}</h5>
                </Col>
                <Col md="1" className="h5 text-muted border">
                  <h5 className="text-right">{totalSum?.totalCost}</h5>
                </Col>
              </Row> */}
            </Container>
          </Row>
          {/* <Container>
            <Row style={{ marginTop: "4rem" }}>
              <Col xs="4" className="border">
                <Row>
                  <Col xs="4" className="border">
                    {" "}
                    <h5 className="text-muted  pt-2 ">Company Price:</h5>
                  </Col>
                  <Col xs="8" className="border">
                    <h5 className="text-muted float-right pt-2 ">{totalSum}</h5>
                  </Col>
                </Row>
                <Row>
                  <Col xs="4" className="border">
                    {" "}
                    <h5 className="text-muted  pt-2 ">Commission</h5>
                  </Col>
                  <Col xs="8" className="border">
                    <h5 className="text-muted float-right pt-2 ">{totalSum}</h5>
                  </Col>
                </Row>
                <Row>
                  <Col xs="4" className="border">
                    {" "}
                    <h5 className="text-muted  pt-2 ">Total Cost</h5>
                  </Col>
                  <Col xs="8" className="border">
                    <h5 className="text-muted float-right pt-2 ">{totalSum}</h5>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container> */}
          <Row style={{ marginTop: "2rem" }}>{""}</Row>
          <Row className="my-1">
            {partnerData?.map((partnerData) => (
              <Container>
                <Row>
                  <Col md="2" className="border">
                    <h5>Partner</h5>
                  </Col>
                  <Col md="1" className="border">
                    <h5>%</h5>{" "}
                  </Col>
                  <Col md="2" className="border">
                    <h5 style={{}}>Remarks</h5>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="h5 text-muted border">
                    <h5>{partnerData?.partner?.label}</h5>
                  </Col>
                  <Col md="1" className="h5 text-muted border">
                    <h5>{due_FormatorsPer(partnerData?.percentage)}%</h5>{" "}
                  </Col>
                  <Col md="2" className="h5 text-muted border">
                    <h5 style={{}}>{partnerData?.pRemarks}</h5>
                  </Col>
                </Row>
              </Container>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
}
